<template>
  <v-container class="pt-10 pb-16 page-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <!-- PAGE TITLE -->
        <h1 class="page-title mb-4">SERVICE PARTNER PRIVACY POLICY </h1>

        <!-- 1 -->
        <section>
          <h3>1. INTRODUCTION</h3>
          <p>
            Gigvoc Technologies Private Limited ("Gigvoc," "we," "us") is committed to managing the digital personal data of our Service Partners ("Data Principals") with high standards of transparency. This policy explains how we collect, process, and protect your professional and personal data.
          </p>
        </section>

        <!-- 2 -->
        <section>
          <h3>2. DATA WE COLLECT FROM PARTNERS</h3>
          <p>To onboard you as a professional on the OhYes platform, we collect:</p>
          <ul>
            <li>
              <strong>KYC & Identity Data:</strong>
              Full name, date of birth, and Aadhaar number (for identity verification and e-Shram portal linking).
            </li>
            <li>
              <strong>Tax & Financial Data:</strong>
              Permanent Account Number (PAN), bank account details for payouts, and GSTIN (if applicable).
            </li>
            <li>
              <strong>Professional Credentials:</strong>
              Trade licenses, certifications, and photos of previous work.
            </li>
            <li>
              <strong>Real-Time Geolocation:</strong>
              We track your precise location when you are marked as "Available" or "On Duty" to assign nearby leads and provide "Live Tracking" to the Customer once a booking is accepted.
            </li>
            <li>
              <strong>Background Verification:</strong>
              Data from third-party agencies regarding criminal records and professional history.
            </li>
          </ul>
        </section>

        <!-- 3 -->
        <section>
          <h3>3. STATUTORY DATA SHARING (SOCIAL SECURITY)</h3>
          <ul>
            <li>
              <strong>Government Portals:</strong>
              In compliance with the Code on Social Security, 2020, we share verified Partner data with the Central Government's e-Shram portal.
            </li>
            <li>
              <strong>Benefit Eligibility:</strong>
              We track and report your "Engagement Days" (the number of days you earned income via the platform). As of 2026, this data is used to determine your eligibility for government-backed social security, insurance, and health benefits.
            </li>
          </ul>
        </section>

        <!-- 4 -->
        <section>
          <h3>4. HOW WE USE YOUR DATA</h3>
          <ul>
            <li>
              <strong>Lead Matching:</strong>
              To notify you of service requests within your geographical range.
            </li>
            <li>
              <strong>Trust & Safety:</strong>
              Your name, profile photo, and rating are shared with the Customer upon booking.
            </li>
            <li>
              <strong>Payment Processing:</strong>
              To calculate earnings, deduct Platform Fees, and process direct bank transfers.
            </li>
            <li>
              <strong>Dispute Resolution:</strong>
              We store in-app chat logs and job completion photos to resolve payment or quality disputes with Customers.
            </li>
          </ul>
        </section>

        <!-- 5 -->
        <section>
          <h3>5. DATA PRINCIPAL RIGHTS (DPDP ACT 2023)</h3>
          <p>As a Service Partner in India, you have the following rights:</p>
          <ul>
            <li>
              <strong>Right to Correction:</strong>
              Update your contact details or bank info through the Partner App.
            </li>
            <li>
              <strong>Right to Erasure:</strong>
              Request deletion of your data if you leave the platform (Note: Some data must be retained for 7 years for GST/audit purposes).
            </li>
            <li>
              <strong>Right to Nominate:</strong>
              You can nominate a person to manage your data and earnings in the event of death or incapacity.
            </li>
          </ul>
        </section>

        <!-- 6 -->
        <section>
          <h3>6. DATA RETENTION & SECURITY</h3>
          <ul>
            <li>
              <strong>Retention:</strong>
              We retain professional and financial records for 7 years to comply with Indian income tax and GST laws.
            </li>
            <li>
              <strong>Security:</strong>
              We use enterprise-grade encryption for Aadhaar and bank data. Data is stored on secure servers within the territory of India.
            </li>
          </ul>
        </section>

        <!-- 7 -->
        <section>
          <h3>7. GRIEVANCE REDRESSAL</h3>
          <p>
            If you have concerns about how your data is handled, you may contact our Grievance Officer:
          </p>
          <ul>
            <li><strong>Name:</strong> [Insert Name]</li>
            <li><strong>Email:</strong> [Insert Email]</li>
            <li><strong>Timeline:</strong> We will acknowledge your query within 24 hours and provide a resolution within 15 days.</li>
          </ul>
        </section>

        <!-- IMPLEMENTATION TIPS -->
        <section>
          <h3>Implementation Tips for Gigvoc Technologies</h3>
          <ol>
            <li>
              <strong>Aadhaar Vault:</strong>
              Since you are collecting Aadhaar for KYC, ensure your tech team uses an "Aadhaar Vault" (masking the numbers) to comply with UIDAI security regulations.
            </li>
            <li>
              <strong>e-Shram Integration:</strong>
              Your onboarding flow should ideally check if the Partner is already registered on e-Shram; if not, you should facilitate this within the app to help them qualify for the 90-day social security rule.
            </li>
            <li>
              <strong>Active Tracking Disclosure:</strong>
              Ensure the Partner App has a prominent "In-App Notification" every time location tracking is active (e.g., a "You are now Online" status bar).
            </li>
          </ol>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PartnerPrivacyIndia",
};
</script>

<style scoped>
.page-title {
  font-size: 34px;
  font-weight: 700;
}

section {
  margin-bottom: 28px;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 6px;
}

p,
li {
  font-size: 15px;
  color: #444;
  line-height: 1.7;
}

ul,
ol {
  padding-left: 20px;
}

ol {
  list-style-type: decimal;
}
</style>
